import { getEntity, denormalizeEntity } from '../entities/selectors';
import { order as orderSchema } from './schema';

const getScope = (state) => state.orders;

export const getIsPOUpdating = (state) => getScope(state).isPOUpdating;

export const getPagination = (state) => getScope(state).pagination;

export const getOrderId = (state) => getScope(state).orderId;

export const getOrder = (state) => {
  const orderId = getOrderId(state);
  return orderId ? getEntity(state, 'orders', orderId) : null;
};

export const getQuoteId = (state) => (getOrder(state) || {}).quoteId;

export const getQuoteNumber = (state) => (getOrder(state) || {}).quoteNumber;

export const getQuoteRevisionNumber = (state) =>
  (getOrder(state) || {}).quoteRevisionNumber;

export const getOrderDenormalized = (state) => {
  const orderId = getOrderId(state);
  return orderId
    ? denormalizeEntity(state, 'orders', orderId, orderSchema)
    : null;
};

export const getQuoteItems = (state) => {
  const order = getOrderDenormalized(state);
  return order ? order.quoteItems : null;
};

export const getChangeOrderStatusFetching = (state) =>
  getScope(state).changeOrderStatusFetching;

export const getPrivateNotes = (state) => (getOrder(state) || {}).privateNotes;

export const getCustomerFacingNotes = (state) =>
  (getOrder(state) || {}).quoteNotes;

export const getCreateShipmentState = (state) => getScope(state).createShipment;

export const getIsCopyOrderQuoteFetching = (state) =>
  getScope(state).isOrderQuoteCopying;

export const getIsExportingInvoicesToCsv = (state) =>
  getScope(state).isExportingInvoicesToCsv;

export const getDownloadFilesState = (state) => getScope(state).downloadFiles;

export const getIsCancellingOrder = (state) =>
  getScope(state).cancelOrder.isFetching;

export const getRefundNotificationState = (state) =>
  getScope(state).refundNotification;

export const getExpandedQuoteItemId = (state) =>
  getScope(state).expandedQuoteItemId;
